import React from 'react';
import Tattoo from './Tattoo.jsx';
import {catalog} from '../db.js';

const Works = () =>
	<section className='works'>
		{
			catalog.map((i,n) =>{
				return <Tattoo key={n} id={i.id} img={i.photo} master={i.master}/>
			})
		}
	</section>

export default Works;